export default __webpack_public_path__ + "static/media/baunebakken-property-05.d0f6d03a.jpg";